module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Task Details",
      "settings": _vm.settings
    },
    on: {
      "save": _vm.saveDocument,
      "show": _vm.initialise
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Document Name"
    },
    model: {
      value: (_vm.document.name),
      callback: function($$v) {
        _vm.$set(_vm.document, "name", $$v)
      },
      expression: "document.name"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hide-details": "",
      "rows": "3",
      "label": "Description"
    },
    model: {
      value: (_vm.document.description),
      callback: function($$v) {
        _vm.$set(_vm.document, "description", $$v)
      },
      expression: "document.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Special Note",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.note),
      callback: function($$v) {
        _vm.$set(_vm.document, "note", $$v)
      },
      expression: "document.note"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Received",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.received),
      callback: function($$v) {
        _vm.$set(_vm.document, "received", $$v)
      },
      expression: "document.received"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Show Advanced Details",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.advanced),
      callback: function($$v) {
        _vm.$set(_vm.form, "advanced", $$v)
      },
      expression: "form.advanced"
    }
  })], 1), _vm._v(" "), (_vm.form.advanced) ? [_c('div', {
    staticClass: "section-heading mt-4"
  }, [_vm._v("Advanced")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Download Link",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.download),
      callback: function($$v) {
        _vm.$set(_vm.document, "download", $$v)
      },
      expression: "document.download"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Save as Template",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.saveAsTemplate),
      callback: function($$v) {
        _vm.$set(_vm.form, "saveAsTemplate", $$v)
      },
      expression: "form.saveAsTemplate"
    }
  }), _vm._v(" "), (_vm.form.saveAsTemplate) ? [_c('v-select', {
    attrs: {
      "items": _vm.lenders,
      "hide-details": "",
      "label": "Lender"
    },
    model: {
      value: (_vm.document.lender),
      callback: function($$v) {
        _vm.$set(_vm.document, "lender", $$v)
      },
      expression: "document.lender"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Category"
    },
    model: {
      value: (_vm.document.category),
      callback: function($$v) {
        _vm.$set(_vm.document, "category", $$v)
      },
      expression: "document.category"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Title"
    },
    model: {
      value: (_vm.document.title),
      callback: function($$v) {
        _vm.$set(_vm.document, "title", $$v)
      },
      expression: "document.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Option Name"
    },
    model: {
      value: (_vm.document.option),
      callback: function($$v) {
        _vm.$set(_vm.document, "option", $$v)
      },
      expression: "document.option"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Global",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.global),
      callback: function($$v) {
        _vm.$set(_vm.document, "global", $$v)
      },
      expression: "document.global"
    }
  })] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e94f4af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/SupplierDocumentDialog.vue
// module id = 2476
// module chunks = 1